"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _style = require("../../DropDown/style");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var selectPrefixCls = '.rc-select';

var effect = function effect() {
  return {
    'animation-duration': '.3 s',
    'animation-fill-mode': 'both',
    'transform-origin': '0 0'
  };
};
/*eslint-disable max-len */


var makeStyle = function makeStyle()
/*{globalVariables = {}} = {}*/
{
  var _selectPrefixCls, _objectSpread2, _$concat3, _$concat4, _$concat6, _$concat7, _$concat8, _$concat9, _global;

  var selectionChoiceColor = '#0099cc';
  var selectionBorderColor = '#cdcdcd';
  var selectInputFontSize = '12px';
  var tagHeight = '17px';
  return {
    '@global': (_global = {
      '@keyframes rcSelectChoiceZoomIn': {
        '0%': {
          transform: 'scale(0.6)',
          opacity: '0'
        },
        '100%': {
          transform: 'scale(1)',
          opacity: 1
        }
      },
      '@keyframes rcSelectChoiceZoomOut': {
        to: {
          transform: 'scale(0)',
          opacity: 0
        }
      },
      '@keyframes rcSelectDropdownSlideUpIn': {
        '0%': {
          opacity: '0',
          transformOrigin: '0% 0%',
          transform: 'scaleY(0)'
        },
        '100%': {
          opacity: 1,
          transformOrigin: '0% 0%',
          transform: 'scaleY(1)'
        }
      },
      '@keyframes rcSelectDropdownSlideUpOut': {
        '0%': {
          opacity: 1,
          transformOrigin: '0% 0%',
          transform: 'scaleY(1)'
        },
        '100%': {
          opacity: 0,
          transformOrigin: '0% 0%',
          transform: 'scaleY(0)'
        }
      },
      '@keyframes rcSelectDropdownSlideDownIn': {
        '0%': {
          opacity: 0,
          transformOrigin: '0% 100%',
          transform: 'scaleY(0)'
        },
        '100%': {
          opacity: 1,
          transformOrigin: '0% 100%',
          transform: 'scaleY(1)'
        }
      },
      '@keyframes rcSelectDropdownSlideDownOut': {
        '0%': {
          opacity: 1,
          transformOrigin: '0% 100%',
          transform: 'scaleY(1)'
        },
        '100%': {
          opacity: 0,
          transformOrigin: '0% 100%',
          transform: 'scaleY(0)'
        }
      }
    }, (0, _defineProperty2["default"])(_global, selectPrefixCls, (_selectPrefixCls = {
      width: '100%',
      fontSize: selectInputFontSize,
      fontWeight: '400',
      fontFamily: 'Arial, Helvetica, sans-serif',
      boxSizing: 'border-box',
      display: 'inline-block',
      position: 'relative',
      verticalAlign: 'middle',
      color: '#666',
      lineHeight: '28px',
      '& ul, li': {
        margin: '0',
        padding: '0',
        listStyle: 'none'
      },
      '& > ul > li > a': {
        padding: '0',
        backgroundColor: '#fff'
      }
    }, (0, _defineProperty2["default"])(_selectPrefixCls, "& ".concat(selectPrefixCls, "-selection__choice"), {
      backgroundColor: selectionChoiceColor,
      color: '#fff',
      borderRadius: '4px',
      "float": 'left',
      padding: '3px 7px',
      marginRight: '5px',
      position: 'relative',
      overflow: 'hidden',
      transition: 'padding .3s cubic-bezier(0.6, -0.28, 0.735, 0.045), width .3s cubic-bezier(0.6, -0.28, 0.735, 0.045)'
    }), (0, _defineProperty2["default"])(_selectPrefixCls, "& ".concat(selectPrefixCls, "-selection__choice__content"), {
      marginLeft: 0,
      marginRight: '6px',
      paddingRight: '6px'
    }), (0, _defineProperty2["default"])(_selectPrefixCls, "& ".concat(selectPrefixCls, "-selection__choice-zoom-enter, & ").concat(selectPrefixCls, "-selection__choice-zoom-appear, & ").concat(selectPrefixCls, "-selection__choice-zoom-leave"), Object.assign({
      opacity: 0,
      'animation-play-state': 'paused',
      'animation-timing-function': 'cubic-bezier(0.175, 0.885, 0.32, 1.275)'
    }, effect())), (0, _defineProperty2["default"])(_selectPrefixCls, "& ".concat(selectPrefixCls, "-selection__choice-zoom-leave"), {
      opacity: 1,
      'animation-timing-function': 'cubic-bezier(0.6, -0.28, 0.735, 0.045)'
    }), (0, _defineProperty2["default"])(_selectPrefixCls, "& ".concat(selectPrefixCls, "-selection__choice-zoom-enter").concat(selectPrefixCls, "-selection__choice-zoom-enter-active, & ").concat(selectPrefixCls, "-selection__choice-zoom-appear").concat(selectPrefixCls, "-selection__choice-zoom-appear-active"), {
      'animation-play-state': 'running',
      'animation-name': 'rcSelectChoiceZoomIn'
    }), (0, _defineProperty2["default"])(_selectPrefixCls, "& ".concat(selectPrefixCls, "-selection__choice-zoom-leave").concat(selectPrefixCls, "-selection__choice-zoom-leave-active"), {
      'animation-play-state': 'running',
      'animation-name': 'rcSelectChoiceZoomOut'
    }), (0, _defineProperty2["default"])(_selectPrefixCls, "& ".concat(selectPrefixCls, "-selection__choice__remove"), {
      color: '#fff',
      cursor: 'pointer',
      fontWeight: 'bold',
      padding: '4px 6px',
      position: 'absolute',
      opacity: 0.7,
      top: 0,
      right: '2px',
      transition: 'opacity .3s',
      '&:before': {
        content: '\'×\''
      },
      '&:hover': {
        color: '#fff'
      }
    }), _selectPrefixCls)), (0, _defineProperty2["default"])(_global, "".concat(selectPrefixCls, "-allow-clear"), (0, _defineProperty2["default"])({}, "& ".concat(selectPrefixCls, "-selection--single ").concat(selectPrefixCls, "-selection__rendered"), {
      paddingRight: '40px'
    })), (0, _defineProperty2["default"])(_global, "".concat(selectPrefixCls, "-arrow"), {
      height: '26px',
      position: 'absolute',
      top: '1px',
      right: '8px',
      width: '20px',
      outline: 'none',
      '& b': {
        borderColor: '#333 transparent transparent transparent',
        borderStyle: 'solid',
        borderWidth: '5px 4px 0 4px',
        height: '0',
        width: '0',
        marginLeft: '-4px',
        marginTop: '-2px',
        position: 'absolute',
        top: '50%',
        left: '50%'
      }
    }), (0, _defineProperty2["default"])(_global, "".concat(selectPrefixCls, "-selection"), {
      minHeight: '31px',
      border: "1px solid ".concat(selectionBorderColor),
      outline: 'none',
      'user-select': 'none',
      '-webkit-user-select': 'none',
      'box-sizing': 'border-box',
      display: 'block',
      'border-radius': '4px'
    }), (0, _defineProperty2["default"])(_global, "".concat(selectPrefixCls, "-selection__placeholder"), {
      position: 'absolute',
      color: '#aaa'
    }), (0, _defineProperty2["default"])(_global, "".concat(selectPrefixCls, "-selection__clear"), {
      fontWeight: 'bold',
      position: 'absolute',
      lineHeight: '28px',
      '&:after': {
        content: '\'×\''
      }
    }), (0, _defineProperty2["default"])(_global, "".concat(selectPrefixCls, "-focused ").concat(selectPrefixCls, "-selection"), {
      borderColor: '#66afe9',
      boxShadow: 'none'
    }), (0, _defineProperty2["default"])(_global, "".concat(selectPrefixCls, "-enabled ").concat(selectPrefixCls, "-selection"), {
      '&:hover': {
        'border-color': '#66afe9' //'box-shadow': `0 0 2px ${Color('#2db7f5').fade(0.2)}`

      },
      '&:active': {
        'border-color': '#66afe9'
      }
    }), (0, _defineProperty2["default"])(_global, "".concat(selectPrefixCls, "-selection--single"), _objectSpread(_objectSpread({
      height: '31px',
      lineHeight: '31px',
      cursor: 'pointer',
      position: 'relative'
    }, _style.dropdownBackground), {}, (_objectSpread2 = {}, (0, _defineProperty2["default"])(_objectSpread2, "& ".concat(selectPrefixCls, "-selection-selected-value"), {
      position: ' absolute',
      left: 0,
      top: 0
    }), (0, _defineProperty2["default"])(_objectSpread2, "& ".concat(selectPrefixCls, "-selection__rendered"), {
      height: '31px',
      position: 'relative',
      display: 'block',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      marginLeft: '10px',
      paddingRight: '20px',
      lineHeight: '28px'
    }), (0, _defineProperty2["default"])(_objectSpread2, "& ".concat(selectPrefixCls, "-selection__clear"), {
      top: 0,
      right: '20px'
    }), _objectSpread2))), (0, _defineProperty2["default"])(_global, "".concat(selectPrefixCls, "-disabled"), (0, _defineProperty2["default"])({
      color: '#ccc',
      cursor: 'not-allowed'
    }, "& ".concat(selectPrefixCls, "-selection--single, & ").concat(selectPrefixCls, "-selection__choice__remove"), {
      cursor: 'not-allowed',
      color: '#ccc',
      '&:hover': {
        cursor: 'not-allowed',
        color: '#ccc'
      }
    })), (0, _defineProperty2["default"])(_global, "".concat(selectPrefixCls, "-search__field__wrap"), {
      display: 'inline-block'
    }), (0, _defineProperty2["default"])(_global, "".concat(selectPrefixCls, "-search__field__placeholder"), {
      position: 'absolute',
      top: '0',
      left: '3px',
      color: '#aaa'
    }), (0, _defineProperty2["default"])(_global, "".concat(selectPrefixCls, "-search--inline"), (_$concat3 = {
      width: '100%'
    }, (0, _defineProperty2["default"])(_$concat3, "& ".concat(selectPrefixCls, "-search__field__wrap"), {
      width: '100%'
    }), (0, _defineProperty2["default"])(_$concat3, "& ".concat(selectPrefixCls, "-search__field"), {
      border: 'none',
      fontSize: selectInputFontSize,
      background: 'transparent',
      outline: '0',
      width: '100%',
      '&::-ms-clear': {
        display: 'none'
      }
    }), (0, _defineProperty2["default"])(_$concat3, "& ".concat(selectPrefixCls, "-search__field__mirror"), {
      position: 'absolute',
      top: '-999px',
      left: '0',
      whiteSpace: 'pre'
    }), (0, _defineProperty2["default"])(_$concat3, '& > i', {
      "float": 'right'
    }), _$concat3)), (0, _defineProperty2["default"])(_global, "".concat(selectPrefixCls, "-enabled").concat(selectPrefixCls, "-selection--multiple"), {
      cursor: 'text'
    }), (0, _defineProperty2["default"])(_global, "".concat(selectPrefixCls, "-selection--multiple"), (_$concat6 = {}, (0, _defineProperty2["default"])(_$concat6, "& ".concat(selectPrefixCls, "-search--inline"), (_$concat4 = {
      marginTop: '3px',
      marginBottom: '3px',
      paddingTop: '3px',
      lineHeight: tagHeight,
      "float": 'left',
      width: 'auto'
    }, (0, _defineProperty2["default"])(_$concat4, "& ".concat(selectPrefixCls, "-search__field"), {
      width: '0.75em'
    }), (0, _defineProperty2["default"])(_$concat4, "& ".concat(selectPrefixCls, "-search__field__wrap"), {
      width: 'auto'
    }), _$concat4)), (0, _defineProperty2["default"])(_$concat6, "& ".concat(selectPrefixCls, "-search__field__placeholder"), {
      top: '5px',
      left: '8px'
    }), (0, _defineProperty2["default"])(_$concat6, "& ".concat(selectPrefixCls, "-selection__rendered"), (0, _defineProperty2["default"])({
      position: 'relative',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      marginLeft: '12px'
    }, "& ".concat(selectPrefixCls, "-selection__choice"), {
      marginTop: '3px',
      marginBottom: '3px',
      lineHeight: tagHeight
    })), (0, _defineProperty2["default"])(_$concat6, "& ".concat(selectPrefixCls, "-selection__clear"), {
      top: '1px',
      right: '8px'
    }), _$concat6)), (0, _defineProperty2["default"])(_global, "".concat(selectPrefixCls, "-enabled"), (_$concat7 = {}, (0, _defineProperty2["default"])(_$concat7, "& ".concat(selectPrefixCls, "-selection__choice"), {
      cursor: 'default',
      '&:hover': (0, _defineProperty2["default"])({}, "& ".concat(selectPrefixCls, "-selection__choice__remove"), {
        opacity: 1
      })
    }), (0, _defineProperty2["default"])(_$concat7, "& ".concat(selectPrefixCls, "-selection__choice__disabled"), {
      cursor: 'not-allowed',
      '&:hover': (0, _defineProperty2["default"])({}, "& ".concat(selectPrefixCls, "-selection__choice__content"), {
        marginLeft: 0,
        marginRight: 0
      })
    }), _$concat7)), (0, _defineProperty2["default"])(_global, "".concat(selectPrefixCls, "-dropdown").concat(selectPrefixCls, "-dropdown-placement-topLeft"), {
      boxShadow: '0 -2px 12px rgba(0,0,0,.175)'
    }), (0, _defineProperty2["default"])(_global, "".concat(selectPrefixCls, "-dropdown"), (_$concat8 = {
      boxShadow: '0 6px 12px rgba(0,0,0,.175)',
      backgroundColor: 'white',
      border: '1px solid #d9d9d9',
      borderRadius: '4px',
      boxSizing: 'border-box',
      zIndex: '100',
      left: '-9999px',
      top: '-9999px',
      position: 'absolute',
      outline: 'none',
      '&:empty, &-hidden': {
        display: 'none'
      },
      '&-menu': {
        outline: 'none',
        margin: 0,
        padding: 0,
        listStyle: 'none',
        zIndex: 9999,
        maxHeight: 300,
        '& > li': {
          margin: 0,
          padding: 0
        }
      },
      '&-menu-item-group-list': {
        margin: 0,
        padding: 0
      }
    }, (0, _defineProperty2["default"])(_$concat8, "&-menu-item-group-list > li".concat(selectPrefixCls, "-menu-item"), {
      paddingLeft: '20px'
    }), (0, _defineProperty2["default"])(_$concat8, '&-menu-item-group-title', {
      color: '#999',
      lineHeight: '1.5',
      padding: '8px 10px',
      borderBottom: '1px solid #dedede'
    }), (0, _defineProperty2["default"])(_$concat8, 'li&-menu-item', {
      margin: 0,
      position: 'relative',
      display: 'block',
      padding: '7px 10px!important',
      fontWeight: 'normal',
      color: '#666',
      whiteSpace: 'nowrap',
      '&-disabled': {
        color: '#ccc',
        cursor: 'not-allowed'
      },
      '&-selected': {
        color: '#666',
        backgroundColor: '#ddd'
      },
      '&-active': {
        backgroundColor: selectionChoiceColor,
        color: 'white',
        cursor: 'pointer'
      },
      '&-divider': {
        height: '1px',
        margin: '1px 0',
        overflow: 'hidden',
        backgroundColor: '#e5e5e5',
        lineHeight: '0'
      }
    }), (0, _defineProperty2["default"])(_$concat8, '&-slide-up-enter, &-slide-up-appear', Object.assign({
      opacity: 0,
      'animation-timing-function': 'cubic-bezier(0.08, 0.82, 0.17, 1)',
      'animation-play-state': 'paused'
    }, effect())), (0, _defineProperty2["default"])(_$concat8, '&-slide-up-leave', Object.assign({
      opacity: 1,
      'animation-timing-function': 'cubic-bezier(0.6, 0.04, 0.98, 0.34)',
      'animation-play-state': 'paused'
    }, effect())), (0, _defineProperty2["default"])(_$concat8, '&-slide-up-enter&-slide-up-enter-active&-placement-bottomLeft, &-slide-up-appear&-slide-up-appear-active&-placement-bottomLeft', {
      'animation-name': 'rcSelectDropdownSlideUpIn',
      'animation-play-state': 'running'
    }), (0, _defineProperty2["default"])(_$concat8, '&-slide-up-leave&-slide-up-leave-active&-placement-bottomLeft', {
      'animation-name': 'rcSelectDropdownSlideUpOut',
      'animation-play-state': 'running'
    }), (0, _defineProperty2["default"])(_$concat8, '&-slide-up-enter&-slide-up-enter-active&-placement-topLeft, &-slide-up-appear&-slide-up-appear-active&-placement-topLeft', {
      'animation-name': 'rcSelectDropdownSlideDownIn',
      'animation-play-state': 'running'
    }), (0, _defineProperty2["default"])(_$concat8, '&-slide-up-leave&-slide-up-leave-active&-placement-topLeft', {
      'animation-name': 'rcSelectDropdownSlideDownOut',
      'animation-play-state': 'running'
    }), _$concat8)), (0, _defineProperty2["default"])(_global, "".concat(selectPrefixCls, "-open"), (_$concat9 = {}, (0, _defineProperty2["default"])(_$concat9, "& ".concat(selectPrefixCls, "-selection"), {
      background: '#fff'
    }), (0, _defineProperty2["default"])(_$concat9, "& ".concat(selectPrefixCls, "-arrow b"), {
      borderColor: 'transparent transparent #333 transparent',
      borderWidth: '0 4px 5px 4px'
    }), _$concat9)), _global)
  };
};
/*eslint-enable max-len */


var _default = makeStyle;
exports["default"] = _default;
//# sourceMappingURL=ant.style.js.map